import type { HelpTopic } from '../../modules/core/index.js'

/** The Performance Summaries add-on's help topics (docs/plans/in-app-help-plan.md). */
export const PERFORMANCE_HELP_TOPICS: readonly HelpTopic[] = [
  {
    id: 'performance_reviews.worker',
    title: 'Your performance summary',
    seats: ['worker'],
    summary: 'A summary of your reliability over a stretch of months that your facility chose to share with you.',
    sections: [
      {
        heading: 'What you see',
        points: [
          'Your tier at the start and end of the span, your average final score and a chart of each month.',
          'The shifts that counted, how steady you were, and how many notes you wrote. Your notes are counted, never quoted.',
          'Earlier summaries shared with you are a tap away.',
        ],
      },
      {
        heading: 'Good to know',
        points: [
          'A summary is fixed when it is made. Later shifts do not change it; a new summary does.',
          'Your facility uses summaries for reviews with HR. Only the ones it shares appear here.',
        ],
      },
    ],
    related: ['scoring.worker-history'],
  },
]
